import {Component, OnInit} from '@angular/core';
import {EnergyMapDonatedComponent} from "../../energy-map/energy.map.donated.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {HeizcheckRequestService} from "../services/heizcheck-request.service";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";
import {MatDialog} from "@angular/material/dialog";

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-heizcheck-energy-map-donated',
    templateUrl: '../../energy-map/energy.map.donated.component.html',
    standalone: false
})
export class HeizcheckEnergyMapDonatedComponent extends EnergyMapDonatedComponent implements OnInit {
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService,
              protected portalService: PortalService, protected requestService: HeizcheckRequestService,
              protected energyMapService: EnergyMapService, public dialog: MatDialog) {
    super(stepService, router, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.advisorName = 'heizcheck';
    this.textkeyPrefix = 'heizcheck';
    this.anfrage = this.requestService.getAnfrage();
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      this.requestService.backendService.getEnergyMapHash(requestId).subscribe(energyMapHash => {
        this.hashCode = energyMapHash;
      });
    });

    super.ngOnInit();

    if (this.router.url.endsWith('/heizcheck/heizkostenabrechnung/energy-map-donated')) {
      if(this.anfrage?.heizkostenanalyseInput?.heiznebenkosten_messgeraet_art === 'verdunster') {
        this.lastStep = '/' + this.portalService.currentPortalId + '/heizcheck/heizkostenabrechnung/sonstiges/1';
      }
      else {
        this.lastStep = '/' + this.portalService.currentPortalId + '/heizcheck/heizkostenabrechnung/sonstiges/3';
      }
      this.nextStep = '/' + this.portalService.currentPortalId + '/heizcheck/auswerten/heizkostenabrechnung';
    }
    else {
      this.lastStep = '/' + this.portalService.currentPortalId + '/heizcheck/verbrauchsanalyse/verbrauchsdaten';
      this.nextStep = '/' + this.portalService.currentPortalId + '/heizcheck/ergebnis/verbrauchsanalyse';
    }
  }
}
